import React from 'react';
import Anchor from 'Components/common/Anchor';
import DeliverCard from 'Components/host/DeliverCard';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {T} from 'Actions/translate';
import {base64ShippingImage} from 'Utils/constant';

class HostShipmentDetailCard extends React.Component {
    state = {
        isExpanded: true,
    };

    render() {
        const {
            shipmentCard,
            orderId,
            roleType,
            onPreviewInvoice,
            onEditTrackingNumber,
            onPreviewOtherPhotos,
            onEditOtherPhotos,
            onPreviewPlacementImage,
            onPreviewB2bShipment,
        } = this.props;
        const {isExpanded} = this.state;
        const canEdit = roleType === 2;
        const canPreviewInvoice = roleType === 1 || canEdit;

        return (
            <li className="shipment-card-li">
                <div className="first-shipment-card">
                    <div className="first-row delivery-id">
                        <div className="card-label">
                            {T('shippment_delivery_id')}
                        </div>
                        <span testid="shipment-delivery-id">
                            {shipmentCard.shipmentId}
                        </span>
                    </div>
                    {shipmentCard.expressNumber ? (
                        <div className="second-row">
                            <div className="card-label">
                                {T('shippment_shipped_express_number')}
                            </div>
                            <span>{shipmentCard.expressNumber}</span>
                        </div>
                    ) : null}
                    <div className="third-row">
                        <div className="card-label">
                            {T('shippment_details_actual_ship_date')}
                        </div>
                        <span>{shipmentCard.shipmentDate}</span>
                    </div>
                    {canPreviewInvoice ? (
                        <div className="fourth-row">
                            <div className="card-label">
                                {T('shippment_delivery_order')}
                            </div>
                            <span className="preview-shipment">
                                <Anchor
                                    className="btn"
                                    onClickOfSingleTap={onPreviewInvoice}>
                                    {T('shippment_preview')}
                                </Anchor>
                                {canEdit ? (
                                    <Anchor
                                        className="btn"
                                        onClickOfSingleTap={
                                            onEditTrackingNumber
                                        }>
                                        {T('shippment_add_tracking_number')}
                                    </Anchor>
                                ) : null}
                            </span>
                        </div>
                    ) : null}
                    <div className="shipment-other-images">
                        <div className="card-label">
                            {T('shippment_other_photos')}
                        </div>
                        <Anchor
                            className="btn"
                            onClickOfSingleTap={onPreviewOtherPhotos}>
                            {T('shippment_preview')}
                        </Anchor>
                        {canEdit ? (
                            <Anchor
                                className="btn edit-other-images-btn"
                                onClickOfSingleTap={onEditOtherPhotos}>
                                {T('shippment_edit_upload')}
                            </Anchor>
                        ) : null}
                    </div>
                    {shipmentCard.receivingCode || shipmentCard.locationImg ? (
                        <div className="fourth-row">
                            {shipmentCard.receivingCode ? (
                                <div className="first-column">
                                    <div className="card-label">
                                        {T('shippment_upload_receive_code')}
                                    </div>
                                    <span>{shipmentCard.receivingCode}</span>
                                </div>
                            ) : null}
                            {shipmentCard.locationImg ? (
                                <div className="second-column">
                                    <div className="card-label localtion-img">
                                        {T(
                                            'shippment_upload_product_placement_photo',
                                        )}
                                    </div>
                                    <span className="preview-shipment">
                                        <Anchor
                                            className="btn"
                                            onClickOfSingleTap={
                                                onPreviewPlacementImage
                                            }>
                                            {T('shippment_preview')}
                                        </Anchor>
                                    </span>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                    {shipmentCard.b2bShipmentFlag === 'Y' ? (
                        <div className="b2b-casmart-btn-container">
                            <img src={base64ShippingImage} alt="" />
                            <label>{T('shippment_b2b_casmart_btn')}</label>
                            <div
                                className="b2b-casmart-order-priview"
                                onClick={() =>
                                    onPreviewB2bShipment({
                                        shipmentId: shipmentCard.shipmentId,
                                        orderId,
                                    })
                                }>
                                {T('shippment_preview')}
                            </div>
                        </div>
                    ) : null}
                    {!isExpanded ? (
                        <div
                            className="deliver-details-switchBtn"
                            onClick={() => this.setState({isExpanded: true})}>
                            <KeyboardArrowDownIcon />
                        </div>
                    ) : null}
                </div>
                {isExpanded && shipmentCard.kitSkuList ? (
                    <DeliverCard
                        kitSkuList={shipmentCard.kitSkuList}
                        changeBtn={isExpanded}
                        index={0}
                        switchBtn={() => this.setState({isExpanded: false})}
                    />
                ) : null}
                <div className="tag wait-received" />
            </li>
        );
    }
}

export default HostShipmentDetailCard;
